module.exports = __webpack_public_path__ + "media/images/front/responsive/clinic_top_page/338629/equipment02-4d7049e5d1e3ef1243be0bacdc161a3d.png";